import sortBy from 'lodash-es/sortBy'

export function filter({ filename }, search) {
  return filename.toLowerCase().includes(search.toLowerCase())
}

export function sortMoreItems(items) {
  return sortBy(items, ['filename'])
}
